import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  Box,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Tooltip,
  Typography,
  CircularProgress,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextareaAutosize,
} from "@material-ui/core";

import { green, orange, red } from "@material-ui/core/colors";
import { spacing } from "@material-ui/system";
import { getProducts } from "../NetworkCalls/Products/ServerReq";
import SearchBar from "../Components/SearchBar";
import ButtonIconComponent from "./ButtonIcons";
import AddQRCodeModal from "./modals/AddQRCodeModal";
import { DateRangePicker } from "@mui/x-date-pickers-pro";
import DateRangeField from "./DateRangeField";
import QRCodeModal from "./modals/QRCodeModal";
import CopyToClipboardButton from "./CopyToClipboardButton";
import FilterBox from "./filterBox";
import {
  AddSingleDoc,
  GetAllData,
  GetAllDataNestedCollections,
  GetAllDataWithNestedCollections,
} from "../NetworkCalls/Admin/ServerReq";
import dayjs from "dayjs";

const headCells = [
  { id: "id", alignment: "left", label: "S.No" },
  { id: "title", alignment: "left", label: "Title" },
  { id: "description", alignment: "left", label: "Description" },
  { id: "businessName", alignment: "left", label: "Restaurant Name" },

  { id: "email", alignment: "left", label: "Email" },
  { id: "status", alignment: "left", label: "Status" },
  { id: "startDate", alignment: "left", label: "Start Date" },
  { id: "endDate", alignment: "left", label: "End Date" },
];
function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
const Divider = styled(MuiDivider)(spacing);
const Paper = styled(MuiPaper)(spacing);

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <Box>
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
                style={{ color: "#969696", fontWeight: 600 }}
              >
                {headCell.label}
              </TableSortLabel>
            </Box>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

let EnhancedTableToolbar = (props) => {
  const { setData, fixedData } = props;
  const [searched, setSearched] = React.useState("");

  return (
    <div
      style={{
        marginTop: "10px",
        display: "flex",
        // width: "350px",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          width: "70%",
          marginLeft: "10px",
          display: "flex",
          gap: "2rem",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" id="tableTitle">
          QR Code:
        </Typography>

        <div
          style={{
            width: "60%",
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <FilterBox
            loader={false}
            options={["Active", "Expired"]}
            name="Filter"
            filterBy="status"
            setData={setData}
            fixedData={fixedData}
            onClick={() => console.log("Template")}
            imageBool={true}
          />

          <Box style={{ width: "100%" }}>
            <SearchBar
              label="Search"
              value={searched}
              onChange={(val) => {
                setSearched(val);
                props.onSearch(val);
              }}
            />
          </Box>
        </div>
      </div>
      <div style={{ width: "15%", marginRight: "20px" }}>
        <ButtonIconComponent
          loader={false}
          name="Add QR Code "
          onClick={props.handleOpen}
          imageBool={false}
        />
      </div>
    </div>
  );
};

function EnhancedTable({ handleOpen }) {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("customer");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [loader, setLoader] = React.useState(false);
  let [data, setData] = React.useState([]);
  const [fixedData, setFixedData] = React.useState([]);
  const [Refresh, setRefresh] = React.useState(false);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await GetAllData("QRCode");

        let arr = [];
        response.forEach((doc) => {
          arr.push(doc.data());
        });

        setData(arr);
        setFixedData(arr);
      } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
      }
    };

    getData();
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  const handleSearch = (val) => {
    console.log(val);
    if (!val) {
      setData(fixedData);
      return;
    }
    const filteredRows = fixedData.filter((row) => {
      return row?.title?.toLowerCase().includes(val?.toLowerCase());
    });
    console.log(filteredRows);
    setData(filteredRows);
  };
  const history = useNavigate();

  const [open, setOpen] = React.useState(false);

  const [DeleteUid, setDeleteUid] = useState("");
  //   const handleOpen = () => {
  //     setOpen(true);
  //   };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Paper
        style={{
          boxShadow: "none !important",
          border: "1px solid rgba(76, 78, 100, 0.25)",
          borderRadius: "10px",
        }}
      >
        <EnhancedTableToolbar
          onSearch={(val) => handleSearch(val)}
          numSelected={selected.length}
          handleOpen={handleOpen}
          setData={setData}
          fixedData={fixedData}
        />
        <TableContainer style={{ height: "47vh", overflowY: "scroll" }}>
          <Table
            aria-labelledby="tableTitle"
            size={"medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={data.length}
            />
            <TableBody>
              {stableSort(data, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={`${row.id}-${index}`}
                      selected={isItemSelected}
                    >
                      <TableCell align="left">
                        <Typography
                          style={{ fontWeight: "600", fontSize: "14px" }}
                        >
                          {index + 1}.
                        </Typography>{" "}
                      </TableCell>

                      <TableCell align="left">
                        {" "}
                        <Typography
                          style={{ fontWeight: "600", fontSize: "14px" }}
                        >
                          {row?.title}
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        {" "}
                        <Typography
                          style={{ fontWeight: "600", fontSize: "14px" }}
                        >
                          {row?.description}
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        {" "}
                        <Typography
                          style={{ fontWeight: "600", fontSize: "14px" }}
                        >
                          {row?.businessName}
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        {" "}
                        <Typography
                          style={{ fontWeight: "600", fontSize: "14px" }}
                        >
                          {row?.email}
                        </Typography>{" "}
                      </TableCell>

                      <TableCell align="center">
                        {" "}
                        <Typography
                          style={{
                            fontWeight: "600",
                            fontSize: "14px",
                            border: "1px solid #808080",
                            borderRadius: "15px",
                            padding: "6px",
                          }}
                        >
                          {row?.status}
                        </Typography>{" "}
                      </TableCell>

                      <TableCell align="left">
                        {" "}
                        <Typography
                          style={{ fontWeight: "600", fontSize: "14px" }}
                        >
                          {row?.startDate}
                        </Typography>{" "}
                      </TableCell>

                      <TableCell align="left">
                        {" "}
                        <Typography
                          style={{ fontWeight: "600", fontSize: "14px" }}
                        >
                          {row?.endDate}
                        </Typography>{" "}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}

const EventsQRCode = () => {
  const [open, setOpen] = useState(false);
  const [Refresh, setRefresh] = React.useState(false);
  const [openQRCode, setOpenQRCode] = useState(false);
  const [addQRCodeData, setAddQRCodeData] = useState({});
  const [qrCodeID, setQRCodeID] = useState("");

  const [addQRCodeLoading, setAddQRCodeLoading] = useState(false);

  const [restaurants, setRestaurants] = useState([]);

  console.log("restaurants=====");
  console.log(restaurants);

  const [restaurantsLoading, setRestaurantsLoading] = useState();

  const [selectedDateRange, setSelectedDateRange] = React.useState([
    dayjs("2023-04-17"),
    dayjs("2023-04-21"),
  ]);

  const handleDateRangeChange = (newDateRange) => {
    setSelectedDateRange(newDateRange);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenQRCode = () => {
    setOpenQRCode(true);
  };

  const handleCloseQRCode = () => {
    setOpenQRCode(false);
  };

  const handleOnchange = (e) => {
    const { name, value } = e.target;
    setAddQRCodeData((preValue) => {
      return {
        ...preValue,
        [name]: value,
      };
    });
  };

  // useEffect(() => {
  //   const getAllRestaurants = async () => {
  //     try {
  //       const response = await GetAllData("Restaurants");

  //       console.log("response");
  //       console.log(response);

  //       let arr = [];
  //       response.forEach((doc) => {
  //         arr.push(doc.data());
  //       });

  //       arr.sort((a, b) => a?.businessName.localeCompare(b?.businessName));

  //       setRestaurants(arr);
  //     } catch (err) {
  //     } finally {
  //     }
  //   };

  //   getAllRestaurants();

  // }, []);


  useEffect(()=>{

    const getData = async () => {
        try {
            const response = await GetAllData("Restaurants");
                let arr = []
                response.forEach((doc) => {
                    arr.push(doc.data())
                });
              
               
             setRestaurants(arr);
        } catch (err) {

        } finally {
        }
    };

    getData()

  }, [])

  const handleAddQRCode = async (e) => {

    e.preventDefault();

    setAddQRCodeLoading(true);

    try {
      const formattedDateRange = selectedDateRange.map((date) =>
        dayjs(date).format("DD/MM/YYYY")
      );
      const currentDate = dayjs();
      const endDate = dayjs(formattedDateRange[1]);

      // Check if the end date is in the future
      const status = currentDate.isBefore(endDate) ? "Active" : "Expired";

      const _id = await AddSingleDoc("QRCode", {
        ...addQRCodeData,
        startDate: formattedDateRange[0],
        endDate: formattedDateRange[1],
        status: status,
      });

      setQRCodeID(_id);

      handleClose();
      handleOpenQRCode();
      setAddQRCodeLoading(false);
    } catch (e) {
      setAddQRCodeLoading(true);
    } finally {
      setAddQRCodeLoading(false);
    }
  };

  return (
    <>
      <AddQRCodeModal
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            marginBottom: "1rem",
          }}
        >
          <Typography
            gutterBottom
            variant="h1"
            style={{
              fontWeight: "600",
              fontSize: "30px",
              textAlign: "center",
              margin: "0",
            }}
          >
            Add QR Code
          </Typography>
        </Box>

        <Box
          style={{
            margin: "2rem 0 0 auto",
          }}
        >
          <form onSubmit={handleAddQRCode}>
            <Grid style={{ marginBottom: "15px" }} container spacing={3}>
              {" "}
              {/* Add spacing prop */}
              <Grid item xs={12} xl={12} lg={12} md={12}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  required
                  onChange={handleOnchange}
                  name="title"
                  label="QR Code Name "
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} xl={12} lg={12} md={12}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="demo-simple-select-label">
                    Select Restaurant
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Enter menu category"
                    required
                    onChange={(e) => {
                      handleOnchange(e);
                      const selectedRestaurantId = e.target.value;
                      const selectedRestaurant = restaurants.find(
                        (restaurant) => restaurant.id === selectedRestaurantId
                      );
                      if (selectedRestaurant) {
                        setAddQRCodeData((preValue) => ({
                          ...preValue,
                          email: selectedRestaurant.email,
                          businessName: selectedRestaurant.businessName,
                        }));
                      }
                    }}
                    name="businessName"
                    //  variant="outlined"
                  >
                    {restaurants &&
                      restaurants.map((item, index) => (
                        <MenuItem key={index} value={item?.id}>
                          {item?.businessName}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} xl={12} lg={12} md={12}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  label="Points"
                  variant="outlined"
                  fullWidth
                  required
                  onChange={handleOnchange}
                  name="points"
                />
              </Grid>
              <Grid item xs={12} xl={12} lg={12} md={12}>
                <DateRangeField onDateRangeChange={handleDateRangeChange} />
              </Grid>
              <Grid item xs={12} xl={12} lg={12} md={12}>
                <FormControl fullWidth={true} variant="outlined">
                  {/* <InputLabel id="description">Desciption</InputLabel> */}
                  <Typography>Desciption</Typography>
                  <TextareaAutosize
                    htmlFor="description"
                    minRows={5}
                    placeholder=""
                    required
                    onChange={handleOnchange}
                    name="description"
                    style={{
                      border: "1px solid #c4c4c4",
                      padding: "10px",
                      fontSize: "18px",
                      outline: "none",
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <ButtonIconComponent
              loader={addQRCodeLoading}
              name="Generate"
              imageBool={false}
              type="submit"
            />
          </form>
        </Box>
      </AddQRCodeModal>

      <QRCodeModal
        open={openQRCode}
        handleOpen={handleOpenQRCode}
        handleClose={handleCloseQRCode}
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            marginBottom: "1rem",
          }}
        >
          <Typography
            gutterBottom
            variant="h1"
            style={{
              fontWeight: "600",
              fontSize: "30px",
              textAlign: "center",
              margin: "0",
            }}
          >
            QR Code
          </Typography>
        </Box>

        <Box
          style={{
            margin: "2rem 0 0 auto",
          }}
        >
          <Box
            style={{
              width: "40%",
              margin: "0 auto",
            }}
          >
            <QRCode
              value={`https://admin.bestlocaleats.net/${qrCodeID}`}
              size="200"
            />
          </Box>

          <Box
            style={{
              margin: "2rem 0 1.2rem 0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "2rem",
            }}
          >
            <Box
              style={{
                display: "flex",
                padding: "0 18px 0 0",
                height: "50px",
                border: "1px solid #898787",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "5px",
              }}
            >
              <CopyToClipboardButton
                text={`https://admin.bestlocaleats.net/${qrCodeID}`}
              />
              <Typography
                style={{
                  color: "#4F4F4F",
                  fontSize: "16px",
                  fontWeight: "400",
                }}
              >
                Copy
              </Typography>
            </Box>

            {/* <Box
              style={{
                display: "flex",
                padding: "0 20px 0 20px",
                height: "50px",
                border: "1px solid #898787",
                justifyContent: "center",
                alignItems: "center",
                gap: "1rem",
                borderRadius: "5px",
              }}
            >
              <img
                src="/assets/share-24px (1) 1.png"
                alt="logo"
                style={{ cursor: "pointer" }}
              />

              <Typography
                style={{
                  color: "#4F4F4F",
                  fontSize: "16px",
                  fontWeight: "400",
                }}
              >
                Share
              </Typography>
            </Box> */}
          </Box>
        </Box>
      </QRCodeModal>

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <EnhancedTable handleOpen={handleOpen} />
        </Grid>
      </Grid>
    </>
  );
};
export default EventsQRCode;
